import { useState } from 'react';
import { money } from './format';
import type { StageBlock } from './deals-api';

// Окно-предупреждение при блокировке перехода этапа (аванс не оплачён / просрочка).
// Объясняет причину и, если это аванс, позволяет принять его в один клик (для роли с «Платежами»).
export function StageBlockModal({
  block,
  dealNo,
  canPay,
  onClose,
  onOpenPay,
  onAcceptAdvance,
}: {
  block: StageBlock;
  dealNo: string;
  canPay: boolean;
  onClose: () => void;
  onOpenPay: () => void;
  onAcceptAdvance?: () => Promise<void>;
}) {
  const [busy, setBusy] = useState(false);
  const isAdvance = block.error === 'payment_required';
  const adv = block.advance;

  return (
    <div className="ovl" onClick={onClose}>
      <div className="modal" style={{ maxWidth: 470 }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-h">
          <div className="grow">
            <div className="m-cli">{isAdvance ? '⛔ Аванс не оплачён' : '⛔ Просрочен платёж'}</div>
            <div className="m-no">{dealNo}</div>
          </div>
          <button className="icon-btn close-x" onClick={onClose}>
            ✕
          </button>
        </div>
        <div className="mbody">
          <p style={{ marginBottom: 10 }}>{block.message}</p>

          {isAdvance && (
            <p className="muted small" style={{ marginBottom: 10 }}>
              Чтобы перевести сделку в «Производство», аванс должен быть получен. Приём аванса — это
              отметка «Оплата» на транше: её ставят на вкладке «Платежи» карточки или на экране
              «Платежи» (обычно бухгалтерия). После этого сделку можно двигать дальше.
            </p>
          )}

          {isAdvance && adv && (
            <div className="glass pad" style={{ margin: '0 0 12px' }}>
              <span className="grow">
                <b>{adv.label}</b>
              </span>{' '}
              <span className="mono" style={{ color: 'var(--gold)' }}>
                {money(adv.amount)}
              </span>
            </div>
          )}

          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
            <button className="btn ghost sm" disabled={busy} onClick={onClose}>
              Отмена
            </button>
            <button className="btn ghost sm" disabled={busy} onClick={onOpenPay}>
              Открыть платежи
            </button>
            {isAdvance && adv && canPay && onAcceptAdvance && (
              <button
                className="btn sm"
                disabled={busy}
                onClick={async () => {
                  setBusy(true);
                  try {
                    await onAcceptAdvance();
                  } finally {
                    setBusy(false);
                  }
                }}
              >
                {busy ? 'Принимаем…' : `Принять аванс · ${money(adv.amount)}`}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
